import { passThroughAxios } from './passThrough.axios'

export default {
  async getInstructionalVideos() {
    try {
      const response = await passThroughAxios.get('videos')
      return response.data
    } catch (e) {
      if (e.response && e.response.status === 404) {
        return []
      }
      return Promise.reject(e)
    }
  },
  async addInstructionalVideo(video) {
    const response = await passThroughAxios.post('admin/tools/videos', video)
    return response.data
  },
  async updateInstructionalVideo(videoId, video) {
    const response = await passThroughAxios.put(`admin/tools/videos/${videoId}`, video)
    return response.data
  },
  async deleteInstructionalVideo(videoId) {
    await passThroughAxios.delete(`admin/tools/videos/${videoId}`)
  },
}
